"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addExtension;

var _last2 = _interopRequireDefault(require("lodash/last"));

var _first2 = _interopRequireDefault(require("lodash/first"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Adds extension to file name
function addExtension(fileName, file) {
  var rootName = (0, _first2["default"])(fileName.split('.'));
  var extension = (0, _last2["default"])(file.name.split('.'));
  return "".concat(rootName, ".").concat(extension);
}